module.exports = __webpack_public_path__ + "static/img/11.20ecb29.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/11.jpg
// module id = s065
// module chunks = 0